import { render } from "./Test.vue?vue&type=template&id=57a530f0&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-57a530f0"

export default script